<template>
    <div class="full-width-message">
        <h2 class="title">
            <slot name="title"></slot>
        </h2>

        <slot name="default"></slot>
    </div>
</template>

<style lang="scss" scoped>
.full-width-message {
    width: 1140px;
    max-width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 80px 20px;

    .title {
        font-family: $parcel-font-stack;
        color: $blue;
        font-size: 2rem;
        line-height: 1.2em;
        font-weight: 400;
        margin: 0 0 30px;
        text-align: center;
    }

    :deep(p) {
        font-size: 1.125rem;
        margin: 0 0 30px;

        &:last-child {
            margin: 0;
        }
    }
}
</style>
